import { render } from "./BottomNavigationAuthComponent.vue?vue&type=template&id=4a19ef80&scoped=true"
import script from "./BottomNavigationAuthComponent.vue?vue&type=script&lang=js"
export * from "./BottomNavigationAuthComponent.vue?vue&type=script&lang=js"

import "./BottomNavigationAuthComponent.vue?vue&type=style&index=0&id=4a19ef80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a19ef80"]])

export default __exports__